import { formateDateString } from '@/util'

export default {
  data () {
    return {
      page: 1
    }
  },

  mounted () {
    this.filters.farm = this.$route.params.farm_id
    this.filters.planned_on_before = formateDateString(new Date().toISOString())
    this.filters.planned_on_after = formateDateString(new Date().toISOString())
  },

  watch: {
    filters: {
      handler () {
        this.page = 1
        this.loadData()
      },
      deep: true
    }
  }
}
